module.exports = __webpack_public_path__ + "media/images/writer/story_achievement_mailer/ogp_image_rank_no8-44e4389ba62de4a4d989f02a2e093797.png";